import PropTypes from 'prop-types';
import React from 'react';

import ResponsiveImage from 'components/ResponsiveImage';
import { cn } from 'utils/Tailwind';

const PageSectionBodyCard = ({ className, data, dataTestId }) => {
  const { mobileImage, desktopImage, contentMarkdown } = data;

  return (
    <div
      className={cn('PdpProductPart group/card odd:group-odd/card my-10 md:my-20', className)}
      {...(dataTestId ? { 'data-testid': dataTestId } : {})}
    >
      <div className="mx-auto flex max-w-screen-2xl flex-col items-center gap-10 px-6 md:flex-row group-odd/card:md:flex-row-reverse">
        <div className="w-full md:w-3/5">
          <div className="md:hidden">
            {mobileImage && (
              <ResponsiveImage
                ratio={`${mobileImage.file.details.image.width}:${mobileImage.file.details.image.height}`}
                src={mobileImage.file.url}
                width={mobileImage.file.details.image.width}
                height={mobileImage.file.details.image.height}
              />
            )}
          </div>
          <div className="hidden md:block">
            {desktopImage && (
              <ResponsiveImage
                ratio={`${desktopImage.file.details.image.width}:${desktopImage.file.details.image.height}`}
                src={desktopImage.file.url}
                width={desktopImage.file.details.image.width}
                height={desktopImage.file.details.image.height}
              />
            )}
          </div>
        </div>
        <div className="content-center md:w-2/5 md:px-6 md:group-odd/card:pl-12 md:group-odd/card:pr-0 md:group-even/card:pl-0 md:group-even/card:pr-12">
          <div dangerouslySetInnerHTML={{ __html: contentMarkdown }} />
        </div>
      </div>
    </div>
  );
};

PageSectionBodyCard.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    contentMarkdown: PropTypes.string,
    desktopImage: PropTypes.shape({
      file: PropTypes.shape({
        details: PropTypes.shape({
          image: PropTypes.shape({
            height: PropTypes.number,
            width: PropTypes.number,
          }),
        }),
        url: PropTypes.string,
      }),
    }),
    mobileImage: PropTypes.shape({
      file: PropTypes.shape({
        details: PropTypes.shape({
          image: PropTypes.shape({
            height: PropTypes.number,
            width: PropTypes.number,
          }),
        }),
        url: PropTypes.string,
      }),
    }),
  }),
  dataTestId: PropTypes.string,
};

export default PageSectionBodyCard;
